import { Routes, Route, Navigate } from 'react-router-dom'
import { DashboardLayout } from './components/layouts/DashboardLayout'
import { Dashboard } from './pages/Dashboard'
import { KnowledgeBaseList } from './pages/KnowledgeBaseList'
import { KnowledgeBaseImport } from './pages/KnowledgeBaseImport'
import { CreateKBWizard } from './pages/knowledge/CreateKBWizard'
import { KnowledgeBaseDetail } from './pages/KnowledgeBaseDetail'
import { AssistantsListPage, CreateAssistantWizard, AssistantDetailPage, AssistantImport } from './pages/assistants'
import { TagsetsList, CreateTagset, TagsetDetail } from './pages/tagsets'
import { GenClairList, GenClairCreate, GenClairDetail } from './pages/genclair'
import IntegrationWizard from './pages/assistants/IntegrationWizard'
import { InteractionsList } from './pages/InteractionsList'
import { InteractionDetail } from './components/interactions/views/InteractionDetail'
import { Actions } from './pages/Actions'
import { TeamList } from './pages/TeamList'
import { Settings } from './pages/Settings'
import { Landing } from './pages/Landing'
import { SignUp } from './pages/SignUp'
import { Login } from './pages/Login'
import { AcceptInvitation } from './pages/AcceptInvitation'
import { PrivateRoute } from './components/auth/PrivateRoute'
import { SRODashboard, SROWizard, SROSessions } from './pages/sro'
import { IngestionPage } from './pages/ingestion/IngestionPage'
import { RunDetailPage as IngestionRunDetailPage } from './pages/ingestion/RunDetailPage'
import { TripletsPage } from './pages/triplets/TripletsPage'
import { RunDetailPage as TripletsRunDetailPage } from './pages/triplets/RunDetailPage'
import { GlobalMemoryPage } from './pages/GlobalMemoryPage'
import { ConnectionsPage } from './pages/connections/ConnectionsPage'

function App() {
  // Single routing structure - no subdomain separation
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<SignUp />} />
      <Route path="/accept-invitation/:token" element={<AcceptInvitation />} />
      
      {/* Authenticated app routes */}
      <Route path="/app" element={<PrivateRoute><DashboardLayout /></PrivateRoute>}>
        <Route index element={<Navigate to="/app/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="knowledge" element={<KnowledgeBaseList />} />
        <Route path="knowledge/create" element={<CreateKBWizard />} />
        <Route path="knowledge/import" element={<KnowledgeBaseImport />} />
        <Route path="knowledge/:kbId" element={<KnowledgeBaseDetail />} />
        <Route path="tagsets" element={<TagsetsList />} />
        <Route path="tagsets/create" element={<CreateTagset />} />
        <Route path="tagsets/:tagsetId" element={<TagsetDetail />} />
        <Route path="genclair" element={<GenClairList />} />
        <Route path="genclair/create" element={<GenClairCreate />} />
        <Route path="genclair/:runId" element={<GenClairDetail />} />
        <Route path="assistants" element={<AssistantsListPage />} />
        <Route path="assistants/create" element={<CreateAssistantWizard />} />
        <Route path="assistants/import" element={<AssistantImport />} />
        <Route path="assistants/:id" element={<AssistantDetailPage />} />
        <Route path="assistants/:id/integrations/wizard" element={<IntegrationWizard />} />
        <Route path="interactions" element={<InteractionsList />} />
        <Route path="interactions/:sessionId" element={<InteractionDetail />} />
        <Route path="actions" element={<Actions />} />
        <Route path="ingestion" element={<IngestionPage />} />
        <Route path="ingestion/:runId" element={<IngestionRunDetailPage />} />
        <Route path="triplets" element={<TripletsPage />} />
        <Route path="triplets/:runId" element={<TripletsRunDetailPage />} />
        <Route path="memory" element={<GlobalMemoryPage />} />
        <Route path="sro" element={<SRODashboard />} />
        <Route path="sro/sessions" element={<SROSessions />} />
        <Route path="sro/create" element={<SROWizard />} />
        <Route path="sro/:configId" element={<SROWizard />} />
        <Route path="connections" element={<ConnectionsPage />} />
        <Route path="team" element={<TeamList />} />
        <Route path="settings" element={<Settings />} />
      </Route>
      
      {/* Catch-all redirect */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}

export default App
